module.exports = __webpack_public_path__ + "media/MRI20C.dfc902f1.mp3";